<template>
  <div class="card">
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-xl font-heading font-semibold text-mifo-primary">
        {{ title }} ({{ orders.length }})
      </h2>
      <div class="flex space-x-2">
        <input
          v-model="searchTerm"
          type="text"
          :placeholder="searchPlaceholder"
          class="input-field w-64"
        />
        <select v-model="statusFilter" class="input-field w-32">
          <option value="">Alle</option>
          <option value="paid">Bezahlt</option>
          <option value="pending">Ausstehend</option>
          <option value="open">Offen</option>
          <option value="expired">Abgelaufen</option>
          <option value="failed">Fehlgeschlagen</option>
          <option value="cancelled">Storniert</option>
          <option value="refunded">Erstattet</option>
        </select>
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Kunde
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Buchungsdatum
            </th>
            <th v-if="showPriceCategory" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Preiskategorie
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Preis
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr
            v-for="order in filteredOrders"
            :key="order.id"
            @click="onRowClick(order)"
            class="hover:bg-gray-50 cursor-pointer transition-colors"
          >
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="flex items-center">
                <div class="flex-shrink-0 h-10 w-10">
                  <div class="h-10 w-10 rounded-full bg-mifo-accent flex items-center justify-center">
                    <span class="text-white font-medium text-sm">
                      {{ order.customer?.firstName?.charAt(0) || '' }}{{ order.customer?.lastName?.charAt(0) || '' }}
                    </span>
                  </div>
                </div>
                <div class="ml-4">
                  <div class="text-sm font-medium text-mifo-primary">
                    {{ order.customer?.firstName || 'Unbekannt' }} {{ order.customer?.lastName || 'Kunde' }}
                  </div>
                  <div class="text-sm text-gray-500">
                    {{ order.customer?.email || 'Keine E-Mail' }}
                  </div>
                </div>
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ formatDate(order.createdAt || order.created_at) }}
            </td>
            <td v-if="showPriceCategory" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ getCourseTypeName(order.courseType) }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ formatCurrency(order.totalAmount || order.total_amount) }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              <StatusPill :value="order.status" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import { formatCurrency, formatDate } from 'shared/utils'
import StatusPill from '@/components/StatusPill.vue'

export default {
  name: 'OrdersTable',
  components: { StatusPill },
  props: {
    title: { type: String, default: 'Bestellungen' },
    orders: { type: Array, default: () => [] },
    showPriceCategory: { type: Boolean, default: true },
    searchPlaceholder: { type: String, default: 'Kunden suchen...' }
  },
  emits: ['row-click'],
  setup(props, { emit }) {
    const searchTerm = ref('')
    const statusFilter = ref('')

    const filteredOrders = computed(() => {
      let filtered = [...props.orders].filter(o => o && o.customer)
      if (searchTerm.value) {
        const t = searchTerm.value.toLowerCase()
        filtered = filtered.filter(o =>
          o.customer?.firstName?.toLowerCase().includes(t) ||
          o.customer?.lastName?.toLowerCase().includes(t) ||
          o.customer?.email?.toLowerCase().includes(t)
        )
      }
      if (statusFilter.value) {
        filtered = filtered.filter(o => o.status === statusFilter.value)
      }
      return filtered
    })

    const onRowClick = (order) => emit('row-click', order)

    const getCourseTypeName = (type) => {
      const types = { standard: 'Standard', assistenzarzt: 'Assistenzarzt' }
      return types[type] || type || ''
    }

    return { searchTerm, statusFilter, filteredOrders, onRowClick, formatCurrency, formatDate, getCourseTypeName }
  }
}
</script>

